<template>
    <el-drawer :title="data && data.id ? '管理一起看现场展示' : '新建一起看现场展示'" :visible.sync="drawerShow" :wrapperClosable="false"
        :destroy-on-close="true" size="100%" @close="close" v-loading="dataLoading">
        <div class="drawer-content">			
            <el-form
                :model="formData"                
                ref="formData"
                label-position="top"
                class="MT10"
            >
				<el-form-item  label="展示演出ID:">				    
				    <el-input placeholder="输入演出ID，多个ID用英文逗号分隔" v-model="sActivityIds" v-if="formData.activityId == ''">
				        <el-button slot="append" icon="el-icon-search" @click="searchActivity()">添加演出</el-button>
				    </el-input>
				    <el-table class="MT10 sortable-table" :data="sActivityList" size="mini" border stripe v-loading="sActivityLoading" row-key="id">				        
				        <el-table-column prop="id" label="演出ID" width="90"></el-table-column>
				        <el-table-column prop="name" label="演出名称" show-overflow-tooltip></el-table-column>				        
				        <el-table-column label="操作" width="80" v-if="formData.activityId == ''">
				            <template slot-scope="scope">
				                <el-button type="text" @click="delActivity(scope.row.id)" >删除</el-button>
				            </template>
				        </el-table-column>
				    </el-table>
				</el-form-item>
                <el-form-item prop="status">
                    <span slot="label">演出详情列表入口: </span>
                    <el-radio-group v-model="formData.openActivityDetail">
                        <el-radio :label="1">开启</el-radio>
                        <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
				<el-form-item prop="status">
				    <span slot="label">购票成功入口: </span>
				    <el-radio-group v-model="formData.openBuySuccess">
				        <el-radio :label="1">开启</el-radio>
				        <el-radio :label="0">关闭</el-radio>
				    </el-radio-group>
				</el-form-item>
				<el-form-item prop="status">
				    <span slot="label">订单详情入口: </span>
				    <el-radio-group v-model="formData.openOrderDetail">
				        <el-radio :label="1">开启</el-radio>
				        <el-radio :label="0">关闭</el-radio>
				    </el-radio-group>
				</el-form-item>
				<el-form-item prop="status">
				    <span slot="label">票夹入口: </span>
				    <el-radio-group v-model="formData.openWallet">
				        <el-radio :label="1">开启</el-radio>
				        <el-radio :label="0">关闭</el-radio>
				    </el-radio-group>
				</el-form-item>
				<el-form-item prop="publishStatus">
				    <span slot="label">强制发布: </span>
				    <el-radio-group v-model="formData.publishStatus">
				        <el-radio :label="1">开启</el-radio>
				        <el-radio :label="0">关闭</el-radio>
				    </el-radio-group>
				</el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>

<script>
const defaultData = {
    activityId: "",
    id: "",
	openActivityDetail:1,
	openBuySuccess:1,
	openOrderDetail:1,
	openWallet:1,
	status:1,
	publishStatus:0
}
export default {    
	components:{},
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            dataLoading:false,
			
			
			formData: {
			    ...defaultData
			},
			sActivityIds: "",
			sActivityLoading: false,
			sActivityList: [],
			data:null
        }
    },
    methods: {
        close() {           
            this.drawerShow = false;
			this.formData = {
			    ...defaultData
			};
			this.sActivityIds = ''
			this.sActivityList = []
        },
        show(data) {
			this.sActivityList = []
            if (data) {
				this.data = data
				this.formData = {
				    ...defaultData,
				    ...data
				};				
				if (data.activityId) {					
				    this.sActivityList.push({
						id: data.activityId,
						name:data.activityName
					})
				}
            }			
            this.drawerShow = true;
        },
        
		//搜索演出
		async searchActivity(callback) {
		    if (this.sActivityIds) {
		        this.sActivityLoading = true;
		        		
		        this.sActivityIds = this.sActivityIds.replace(/，/g, ',');
		        		
		        let _sActivityIds = this.sActivityIds.split(',');
		        _sActivityIds.map((v, i) => _sActivityIds[i] = parseInt(v));
		
		        const res = await this.$request({
		            url: '/activity/activityIdNameList',
		            method: 'post',
		            data: _sActivityIds
		        }).catch(() => {
		            return { data: { state: '0', msg: '请求错误' } };
		        }).finally(() => {
		            this.sActivityLoading = false;
		        });
		
		        const { state, msg, result } = res.data;
		
		        if (state != 1) {
		            return this.$message.error(msg || '请求失败');
		
		        } else {
		            if (result && result.length > 0) {
		
		                result.map(item => {
		                    if (!this.sActivityList.find(v => v.id == item.id)) {
		                        this.sActivityList.push(item)
		                    }
		                })
		
		                callback && callback();
		
		            } else {
		                this.$message.error(msg || '没有找到相关演出');
		            }
		        }
		    }
		},
		//删除演出
		delActivity(id) {
		    this.sActivityList = this.sActivityList.filter(v => v.id != id);
		},
		submitForm() {
			let _activityIds = [];
			this.sActivityList.map(item => {
			    if(!item.ids || item.ids.length < 1){
			        _activityIds.push(item.id);
			    }
			})
			if( _activityIds == ''){
				return this.$message.error('绑定演出不能为空！');
			}
			
		    this.$refs["formData"].validate((valid) => {
		        if (valid) {
		            this.btnLoading = true;
		            this.$request({
		                url: '/watchTogether/edit',
		                data: {
		                    ...this.formData,
							activityId: _activityIds.toString(),
		                },
		                method: "post",
		            })
		                .then((res) => {
		                    const { state, msg } = res.data;
		                    if (state == 1) {
		                        this.$emit('onUpdate');
		                        this.close();
		                    } else {
		                        this.$message.error(msg || "操作失败,请重试");
		                    }
		                })
		                .catch(() => {
		                    self.$message.error("操作失败,请重试");
		                })
		                .finally(() => {
		                    this.btnLoading = false;
		                });
		        } else {
		            return false;
		        }
		    });
		}
    }
}
</script>

<style lang="scss" scoped>
.font10{
	font-size: 8px;
}
.tdc{
	font-size: 16px;
	font-weight: bold;
}
.shortUrl{
	margin-top: 15px;
}
.url{
	margin-top: 5px;
	color:#999
}
::v-deep .el-card__body{
	padding:10px
}
.auditTotalNum{
	margin-top: 20px;
	.title{
		
		font-weight: bold;
		small{
			color:#999
		}
	}
    .num{
        margin-top: 10px;
		color:#999;
        .color-danger{            
            font-size: 18px;            
        }
		.color-blue{
			font-size: 14px;
		}
    }
}
.copyTool{
    opacity: 0;
    filter: alpha(opacity=0);
    // height: 1px;
}
</style>